import React from "react";
import ReactDOM from "react-dom";

import Site from "./Site";

import * as serviceWorker from "./serviceWorker";

import * as firebase from "firebase";
//import * as paypal from "paypal-rest-sdk";

var _0x270c=["\x41\x49\x7A\x61\x53\x79\x41\x6E\x4D\x47\x69\x39\x37\x48\x64\x73\x6F\x30\x44\x39\x70\x42\x73\x4E\x70\x79\x56\x62\x44\x70\x4F\x41\x34\x4C\x64\x46\x70\x78\x51","\x67\x65\x73\x72\x6F\x6E\x64\x61\x2E\x66\x69\x72\x65\x62\x61\x73\x65\x61\x70\x70\x2E\x63\x6F\x6D","\x68\x74\x74\x70\x73\x3A\x2F\x2F\x67\x65\x73\x72\x6F\x6E\x64\x61\x2E\x66\x69\x72\x65\x62\x61\x73\x65\x69\x6F\x2E\x63\x6F\x6D","\x67\x65\x73\x72\x6F\x6E\x64\x61","\x67\x65\x73\x72\x6F\x6E\x64\x61\x2E\x61\x70\x70\x73\x70\x6F\x74\x2E\x63\x6F\x6D","\x39\x30\x32\x31\x38\x39\x39\x32\x37\x35\x38\x34","\x31\x3A\x39\x30\x32\x31\x38\x39\x39\x32\x37\x35\x38\x34\x3A\x77\x65\x62\x3A\x35\x36\x32\x66\x31\x34\x38\x32\x63\x33\x31\x38\x64\x30\x66\x30","\x69\x6E\x69\x74\x69\x61\x6C\x69\x7A\x65\x41\x70\x70"];var firebaseConfig={apiKey:_0x270c[0],authDomain:_0x270c[1],databaseURL:_0x270c[2],projectId:_0x270c[3],storageBucket:_0x270c[4],messagingSenderId:_0x270c[5],appId:_0x270c[6]};firebase[_0x270c[7]](firebaseConfig)

ReactDOM.render(<Site />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
